import React from 'react';
import PropTypes from 'prop-types';

import styles from './playersList.scss';

// Loading skeleton: `rowCount` shimmer rows (desktop) or cards (mobile) sized to the incoming page so
// real rows drop in with no layout shift. Every column shimmers; the header labels above stay live and
// are disabled by the parent. Mirrors the SidebarPowerCheckout StripePlaceholder approach with the
// LoadingCard shimmer (see playersList.scss).
const PlayersLoading = ({ rowCount, isMobile, 'data-testid': dataTestId }) => {
    const rows = Array.from({ length: rowCount }, (unused, index) => index);

    if (isMobile) {
        return (
            <div className={styles.loading} data-testid={dataTestId || undefined}>
                {rows.map(index => (
                    <div
                        key={index}
                        className={styles.skeletonCard}
                        data-testid={dataTestId && `${dataTestId}.row-${index}`}
                    >
                        <span className={`${styles.shimmer} ${styles.skeletonAvatar}`} />
                        <div className={styles.skeletonCardInfo}>
                            <span className={`${styles.shimmer} ${styles.skeletonName}`} />
                            <span className={`${styles.shimmer} ${styles.skeletonMeta}`} />
                        </div>
                        <span className={`${styles.shimmer} ${styles.skeletonRating}`} />
                        <span className={`${styles.shimmer} ${styles.skeletonRating}`} />
                        <span className={`${styles.shimmer} ${styles.skeletonMenu}`} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={styles.loading} data-testid={dataTestId || undefined}>
            {rows.map(index => (
                <div
                    key={index}
                    className={styles.skeletonRow}
                    data-testid={dataTestId && `${dataTestId}.row-${index}`}
                >
                    <span className={styles.activityCol} />
                    <div className={styles.nameCol}>
                        <span className={`${styles.shimmer} ${styles.skeletonAvatar}`} />
                        <div className={styles.nameInfo}>
                            <span className={`${styles.shimmer} ${styles.skeletonName}`} />
                            <span className={`${styles.shimmer} ${styles.skeletonMeta}`} />
                        </div>
                    </div>
                    <div className={styles.singlesCol}>
                        <span className={`${styles.shimmer} ${styles.skeletonRating}`} />
                    </div>
                    <div className={styles.doublesCol}>
                        <span className={`${styles.shimmer} ${styles.skeletonRating}`} />
                    </div>
                    <div className={styles.recentResultsCol}>
                        <span className={`${styles.shimmer} ${styles.skeletonActivity}`} />
                    </div>
                    <div className={styles.eventActivityCol}>
                        <span className={`${styles.shimmer} ${styles.skeletonActivity}`} />
                    </div>
                    <span className={styles.noteCol} />
                    <div className={styles.menuCol}>
                        <span className={`${styles.shimmer} ${styles.skeletonMenu}`} />
                    </div>
                </div>
            ))}
        </div>
    );
};

PlayersLoading.propTypes = {
    rowCount: PropTypes.number,
    isMobile: PropTypes.bool,
    'data-testid': PropTypes.string,
};

PlayersLoading.defaultProps = {
    rowCount: 0,
    isMobile: false,
    'data-testid': null,
};

export default PlayersLoading;
